import { Container as RBContainer, Row as RBRow, Col as RBCol } from 'react-bootstrap';
import PropTypes from 'prop-types';

/**
 * A simple wrapper around a Bootstrap Container
 * @component
 */
export const Container = ({ children, fluid, props }) => <RBContainer fluid={fluid} {...props}>{children}</RBContainer>;

Container.propTypes = {
    children: PropTypes.node
}

/**
 * A simple wrapper around a Bootstrap grid Row
 * @component
 */
export const Row = ({ children, ...props }) => <RBRow noGutters={true} {...props}>{children}</RBRow>;

Row.propTypes = {
    children: PropTypes.node
}

/**
 * A simple wrapper around a Bootstrap grid Col
 * @component
 */
export const Col = ({ children, ...props }) => <RBCol {...props}>{children}</RBCol>;

Col.propTypes = {
    children: PropTypes.node
}